// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mbnk","questions":"styles_questions__2dq28","footer":"styles_footer__DYRpD"};